import {
    SUCCESS_GET_ALL_ROUTING_RULES,
    FAILED_GET_ALL_ROUTING_RULES,
    SUCCESS_GET_ROUTING_RULE,
    FAILED_GET_ROUTING_RULE,
    SUCCESS_CREATE_ROUTING_RULE,
    FAILED_CREATE_ROUTING_RULE,
    SUCCESS_UPDATE_ROUTING_RULE,
    FAILED_UPDATE_ROUTING_RULE,
    SUCCESS_DELETE_ROUTING_RULE,
    FAILED_DELETE_ROUTING_RULE,
} from '../constants/routingRuleConstants';

const defaultState = {
    successMessage: null,
    errorMessage: null,
    allRoutingRules: [],
    routingRule: null,
};

export const RoutingRuleReducer = (state = defaultState, action) => {
    const { type, allRoutingRules, routingRule, errorMessage, deletedId } = action;
    switch (type) {
        case SUCCESS_GET_ALL_ROUTING_RULES:
            return {
                ...state,
                allRoutingRules: allRoutingRules || [],
                errorMessage: null,
            };
        case SUCCESS_GET_ROUTING_RULE:
        case SUCCESS_CREATE_ROUTING_RULE:
        case SUCCESS_UPDATE_ROUTING_RULE:
            return {
                ...state,
                routingRule: routingRule || null,
                errorMessage: null,
            };
        case SUCCESS_DELETE_ROUTING_RULE:
            return {
                ...state,
                allRoutingRules: (state.allRoutingRules || []).filter(r => r.id !== deletedId),
                routingRule: null,
                errorMessage: null,
            };
        case FAILED_GET_ALL_ROUTING_RULES:
        case FAILED_GET_ROUTING_RULE:
        case FAILED_CREATE_ROUTING_RULE:
        case FAILED_UPDATE_ROUTING_RULE:
        case FAILED_DELETE_ROUTING_RULE:
            return {
                ...state,
                errorMessage: errorMessage || null,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducers/routingRuleReducer.js